import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useParticipation } from '@app/api';
import { Notification } from './Notification';
import { useNavigate } from 'react-router-dom';
import { Button } from '@app/core';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  mainContainer: {
    display: 'flex',
    gap: theme.marginBase * 2,
    [theme.media.mobile]: {
      flexDirection: 'column',
      gap: 0,
    },
  },
  title: {
    ...theme.fonts.h5,
    marginBottom: theme.marginBase,
  },
  content: {
    ...theme.fonts.caption,
  },
  ellipsis: {
    overflow: 'hidden',
    width: '100%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.marginBase * 2,
    alignItems: 'center',
    flex: 1,
    width: '100%',
  },
}));

interface Props {
  participationId: string;
  message: string;
}

export const NewMessageNotification = ({ participationId, message }: Props) => {
  const classes = useStyles();
  const { data: participation } = useParticipation(participationId);
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!participation) {
    return null;
  }

  return (
    <Notification title="New Message" icon="ri-chat-3-line">
      {participation?.session?.title && (
        <div className={classes.title}>{participation.session.title}</div>
      )}
      <div className={classes.mainContainer}>
        <div className={classes.textContainer}>
          <p className={classes.ellipsis}>{message}</p>
          <Button
            variant="muted"
            text={t(`notification.newMessage.button`)}
            small
            withNextArrow
            onClick={() => {
              navigate(`/p/${participationId}?tab=messages`);
            }}
          />
        </div>
      </div>
    </Notification>
  );
};
